export const RUNTIME_BASE_URL = (() => {
  let value
  try {
    value = process.env.RUNTIME_BASE_URL
  } catch (e) {}
  return value || 'https://cloudflareworkers.com'
})()

export const DEVTOOLS_URL = (() => {
  let value
  try {
    value = process.env.DEVTOOLS_URL
  } catch (e) {}
  return (
    value ||
    localStorage.getItem('DEVTOOLS_URL') ||
    'https://cloudflareworkers.com/devtools-ui/f42931e03c455dd9f7766893671ea3e2e97de03e/cf_app.html'
  )
})()



// WEBPACK FOOTER //
// ./src/lib/config.ts